import React from 'react';

const SvgDj = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="DJ_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="DJ_svg__b" fill="#fff">
        <use xlinkHref="#DJ_svg__a" />
      </mask>
      <use fill="#FFF" xlinkHref="#DJ_svg__a" />
      <path fill="#1DC837" mask="url(#DJ_svg__b)" d="M0 9.333h28V20H0z" />
      <path fill="#82C5F5" mask="url(#DJ_svg__b)" d="M0 0h28v9.333H0z" />
      <path fill="#FFF" mask="url(#DJ_svg__b)" d="M0 0l13.333 10L0 20z" />
      <path
        fill="#E21C21"
        mask="url(#DJ_svg__b)"
        d="M4.667 11.3l-1.96 1.397.723-2.295L1.496 8.97l2.407-.022.764-2.281.764 2.281 2.406.022-1.934 1.432.723 2.295z"
      />
    </g>
  </svg>
);

export default SvgDj;
